module.exports = __webpack_public_path__ + "static/media/thumb.6c960206.jpg";